module.exports = __webpack_public_path__ + "static/media/default-avatar.041de71d.svg";